import React from 'react';
import WhatsappIcon from '../assets/icons/whatsapp.svg';
import InstagramIcon from '../assets/icons/instagram96.svg';


const Footer = () => {
    const handleWhatsAppClick = (e) => {
        e.preventDefault();
        window.open("https://wa.me/5511930693338?text=Oi!%20Gostaria%20de%20receber%20atendimento.", "_blank");
        // Rastreamento de conversão do Google Ads
        if (window.gtag) {
            window.gtag('event', 'conversion', {
                'send_to': 'AW-16944490858/aL4_CM-jl7MaEOrS4Y8_',
                'value': 1
            });
        }
    };

    return (
        <footer className="footer">
            <div className="footer-content">
                <h3>Odontologia Guion</h3>               
                <ul className="socials">                                    
                <li><a href="#" onClick={handleWhatsAppClick}><i className="fa fa-whatsapp"></i>(11) 93069-3338</a></li>                
                <li><a href="http://www.instagram.com/odontologiaguion/" target="_blank"><i className="fa fa-instagram"></i> odontologiaguion</a></li>

                </ul>                
            </div>
            <div className="footer-bottom">
                <p>Copyright &copy;2025 Odontologia Guion.<br/>Desenvolvido por <span><a href="http://www.convertrex.com.br" target="_blank">Convertrex</a></span></p>
            </div>

            <a className="whatsapp" href="#" onClick={handleWhatsAppClick}>
                <img src={WhatsappIcon} alt="Fale Conosco pelo WhatsApp" />
            </a>
            <a className="instagram" href="https://www.instagram.com/odontologiaguion/" target="_blank">
                <img src={InstagramIcon} alt="Instagram" />
            </a>

        </footer>
    );
};

export default Footer;